import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { useMemo } from 'react';
import { ScopeOfWork_DeliverableStatus } from '@/modules/__generated__/graphql/switchboard-generated';
import { DeliverableStatusChip } from '@/modules/shared/components/chips/deliverable-status-chip';
import { DrawerSelect } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { MultipleSelector, type Option } from '@/modules/shared/components/form/multiselect';
interface StatusSelectProps {
  statuses: ScopeOfWork_DeliverableStatus[];
  setStatuses: (statuses: ScopeOfWork_DeliverableStatus[]) => Promise<URLSearchParams>;
  className?: string;
}
const statusOptions: Option[] = [{
  value: ScopeOfWork_DeliverableStatus.Draft,
  label: <DeliverableStatusChip status={ScopeOfWork_DeliverableStatus.Draft} />,
  group: 'Statuses'
}, {
  value: ScopeOfWork_DeliverableStatus.InProgress,
  label: <DeliverableStatusChip status={ScopeOfWork_DeliverableStatus.InProgress} />,
  group: 'Statuses'
}, {
  value: ScopeOfWork_DeliverableStatus.Canceled,
  label: <DeliverableStatusChip status={ScopeOfWork_DeliverableStatus.Canceled} />,
  group: 'Statuses'
}, {
  value: ScopeOfWork_DeliverableStatus.Delivered,
  label: <DeliverableStatusChip status={ScopeOfWork_DeliverableStatus.Delivered} />,
  group: 'Statuses'
}, {
  value: ScopeOfWork_DeliverableStatus.Todo,
  label: <DeliverableStatusChip status={ScopeOfWork_DeliverableStatus.Todo} />,
  group: 'Statuses'
}, {
  value: ScopeOfWork_DeliverableStatus.WontDo,
  label: <DeliverableStatusChip status={ScopeOfWork_DeliverableStatus.WontDo} />,
  group: 'Statuses'
}, {
  value: ScopeOfWork_DeliverableStatus.Blocked,
  label: <DeliverableStatusChip status={ScopeOfWork_DeliverableStatus.Blocked} />,
  group: 'Statuses'
}];
function StatusSelectDeliverable(t0) {
  const $ = _c(11);
  const {
    statuses,
    setStatuses,
    className
  } = t0;
  let t1;
  if ($[0] !== statuses) {
    t1 = statusOptions.filter(option => statuses.includes(option.value as ScopeOfWork_DeliverableStatus));
    $[0] = statuses;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedOptions = t1;
  let t2;
  if ($[2] !== setStatuses) {
    t2 = options => {
      const values = options.map(_temp);
      setStatuses(values);
    };
    $[2] = setStatuses;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleChange = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("bg-background");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className) {
    t4 = {
      className
    };
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleChange || $[8] !== selectedOptions || $[9] !== t4) {
    t5 = <MultipleSelector value={selectedOptions} onChange={handleChange} options={statusOptions} enableSearch={false} groupBy="group" enableSelectAll={true} selectAllGroup="Statuses" placeholder="All Statuses" className={t3} commandProps={t4} customItemRenderer={_temp2} />;
    $[7] = handleChange;
    $[8] = selectedOptions;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2(option_1) {
  return <DeliverableStatusChip status={option_1.value as ScopeOfWork_DeliverableStatus} />;
}
function _temp(option_0) {
  return option_0.value as ScopeOfWork_DeliverableStatus;
}
function StatusSelectDelivarableDrawer(t0) {
  const $ = _c(5);
  const {
    statuses,
    setStatuses
  } = t0;
  let t1;
  if ($[0] !== setStatuses) {
    t1 = values => {
      setStatuses(values as ScopeOfWork_DeliverableStatus[]);
    };
    $[0] = setStatuses;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== handleChange || $[3] !== statuses) {
    t2 = <DrawerSelect value={statuses} onChange={handleChange} label="Statuses" options={statusOptions} multiselect={true} enableSelectAll={true} selectAllLabel="Select All" />;
    $[2] = handleChange;
    $[3] = statuses;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { StatusSelectDeliverable, StatusSelectDelivarableDrawer };